import {
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  makeStyles,
} from '@material-ui/core';
import Button from 'components/Button/Button';
import DialogHeader from 'components/DialogHeader/DialogHeader';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { activateChatbotLicenceThunk } from 'scenes/Settings/ChatbotAnalytics/store/thunks/chatbotAnalyticsThunks';
import { ConfirmChatbotLicenceForm } from './confirm-chatbot-licence-form/ConfirmChatbotLicenceForm';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';

export const ConfirmSubscribeDialog = ({ onClose }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [newBusinessId, setNewBusinessId] = useState('');
  const [businessName, setNewBusinessName] = useState('');

  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      ...theme.component.dialogPaper,
      [theme.breakpoints.down('xs')]: {
        ...theme.component.dialogPaperFullscreen,
      },
    },
    dialogContent: {
      paddingTop: theme.spacing(2),
      height: '600px',
    },
    dialogActions: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  }));

  const classes = useStyles();

  const { t } = useTranslation('common');

  const handleSubmit = () => {
    const item = {
      businessId: newBusinessId,
      businessName: businessName,
    };
    console.log(item);
    dispatch(activateChatbotLicenceThunk(item));

    enqueueSnackbar('Chatbot lisenssi ostettu onnistuneesti', {
      variant: 'success',
    });
    onClose();
    history.push('/');
  };

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      fullWidth
      maxWidth="sm"
      open={true}
      onClose={onClose}
    >
      <DialogHeader title={'Vahvista Osto'} onClose={onClose} />
      <DialogContent className={classes.dialogContent}>
        <h3 style={{ fontWeight: 'bold' }}>
          {`Oletko varma että haluat ostaa nerobotin?`}
        </h3>

        <ConfirmChatbotLicenceForm
          newBusinessId={newBusinessId}
          setNewBusinessId={setNewBusinessId}
          businessName={businessName}
          setNewBusinessName={setNewBusinessName}
        ></ConfirmChatbotLicenceForm>
      </DialogContent>

      <Divider />
      <DialogActions className={classes.dialogActions}>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button color="primary" onClick={() => handleSubmit()}>
          Osta
        </Button>
      </DialogActions>
    </Dialog>
  );
};
